import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { generateAutomationName } from "../../../../../helpers/generateAutomationName";

import { FilterCardWrapper } from "./FilterCardWrapper";

const FIELD_HEIGHT = 36;

export const FilterCardSkeleton = () => (
    <FilterCardWrapper data-automation={generateAutomationName("settings", ["news", "filter", "skeleton"])}>
        <PixelPlaceholderLoader
            width="100%"
            height={FIELD_HEIGHT}
        />

        <Flex
            gap="16px"
            justifyContent="space-between"
        >
            <PixelPlaceholderLoader
                width="100%"
                height={FIELD_HEIGHT}
            />
            <PixelPlaceholderLoader
                width="100%"
                height={FIELD_HEIGHT}
            />
        </Flex>
    </FilterCardWrapper>
);
